/**
 *
 * @param {Object} param0
 * @param {string} param0.path
 * @param {Object} param0.options
 * @param {boolean} param0.expectJson
 * @param {Object} param0.error
 * @param {string} param0.url
 */
export const sendRequest = async ({
  path,
  options,
  expectJson,
  error,
  url,
}) => {
  try {
    if (!(path && url)) throw new Error("Request needs path and url.");
    const response = await fetch(`${url}${path}`, options);
    if (response.ok) {
      console.log("OK body");
      console.log(response);
      if (expectJson) {
        const body = await response.json();
        return {
          ok: true,
          data: body,
        };
      } else {
        return {
          ok: true,
          data: {},
        };
      }
    }
    throw new Error({ ...error, status: response.statusCode });
  } catch (error) {
    console.error("Error");
    console.error(error);
    return {
      ok: false,
      error,
    };
  }
};
